if (!Element.prototype.fitsWrapper) {

    /***
     * Checks if the element fits the viewport width
     * @param container - if exist checks if element fits container width
     */
    Element.prototype.fitsWrapper = function (container) {
        var rect = this.getBoundingClientRect();
        var html = document.documentElement;

        if (container) {
            html = container.getBoundingClientRect();
            return rect.left >= 0 && rect.right <= html.right;
        }

        return (
            rect.left >= 0 &&
            rect.right <= (html.clientWidth || window.innerWidth)
        );
    }
}